import React from 'react';
import Router from './routes';
import './App.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-tooltip/dist/react-tooltip.css'



function App() {
  return (
   <React.Fragment>
    <Router />
    <ToastContainer />
   </React.Fragment>
  );
}

export default App;
